import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { countries } from "../../../utilities/countries";
import  {
  pendforapprovProducts,
  pendingProducts,
  rejectedProducts,
  searchManufacturers,
} from "../../../../src/seller-apis/apidataField";
import './FormStyles.css'; // Import the shared styles

export const BasicInformation = ({ formData, updateFormData, servicesApi, api ,onNext,  validationErrors = {} }) => {
  const [charCount, setCharCount] = useState({
    productName: formData.productName?.length || 0,
    shortDescription: formData.shortDescription?.length || 0
  });

  // Category selection states
  const [grandCategories, setGrandCategories] = useState([]);
  const [selectedGrandCategory, setSelectedGrandCategory] = useState(formData.grandCategory || "");
  const [parentCategories, setParentCategories] = useState([]);
  const [selectedParentCategory, setSelectedParentCategory] = useState(formData.parentCategory || "");
  const [childCategories, setChildCategories] = useState([]);
  const [selectedChildCategory, setSelectedChildCategory] = useState(formData.childCategory || "");
  const [grandChildCategories, setGrandChildCategories] = useState([]);
  const [selectedGrandChildCategory, setSelectedGrandChildCategory] = useState(formData.grandChildCategory || "");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false); 
  const [brandList, setbrandList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');

  const [brand, setbrand] = useState(formData.brand || "");
  const [brandInput, setbrandInput] = useState(formData.brand || "");
  const [brandid, setbrandid] = useState(formData.brandid || "");

  // NEW: State for "Same as Manufacturer Details" checkbox
  const [sameAsManufacturer, setSameAsManufacturer] = useState(formData.sameAsManufacturer || false);

  // Additional state for keywords functionality
  const [currKeyword, setcurrKeyword] = useState("");
  const [categoryPath, setCategoryPath] = useState("");

  // NEW: Refs for form fields to enable auto-scrolling
  const productNameRef = useRef(null);
  const grandCategoryRef = useRef(null);
  const parentCategoryRef = useRef(null);
  const childCategoryRef = useRef(null);
  const grandChildCategoryRef = useRef(null);
  const countryOfOriginRef = useRef(null);
  const brandRef = useRef(null);
  const keywordsRef = useRef(null);
  const shortDescriptionRef = useRef(null);
  const fullDescriptionRef = useRef(null);

  // NEW: Auto-scroll to first validation error
  useEffect(() => {
    if (validationErrors && Object.keys(validationErrors).length > 0) {
      // Map of field names to their refs
      const fieldRefMap = {
        productName: productNameRef,
        grandCategory: grandCategoryRef,
        parentCategory: parentCategoryRef,
        childCategory: childCategoryRef,
        grandChildCategory: grandChildCategoryRef,
        countryOfOrigin: countryOfOriginRef,
        brand: brandRef,
        brandid: brandRef,
        keywords: keywordsRef,
        shortDescription: shortDescriptionRef,
        fullDescription: fullDescriptionRef
      };

      // Find the first error field that has a ref
      const firstErrorField = Object.keys(validationErrors).find(field => fieldRefMap[field]);
      
      if (firstErrorField && fieldRefMap[firstErrorField]?.current) {
        // Scroll to the field
        fieldRefMap[firstErrorField].current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        
        // Focus on the field after a short delay
        setTimeout(() => {
          fieldRefMap[firstErrorField].current.focus();
        }, 300);
      }
    }
  }, [validationErrors]);

  useEffect(() => {
    loadCategoryTree();
  }, []);

  useEffect(() => {
  if (updateFormData) {
    updateFormData('_categoryLevels', {
      hasParentCategories: parentCategories.length > 0,
      hasChildCategories: childCategories.length > 0,
      hasGrandChildCategories: grandChildCategories.length > 0
    });
  }
}, [parentCategories.length, childCategories.length, grandChildCategories.length]);

  // Sync brand data when formData changes
  useEffect(() => {
    if (formData.brand && formData.brand !== brandInput) {
      setbrandInput(formData.brand);
      setbrand(formData.brand);
    }
    if (formData.brandid && formData.brandid !== brandid) {
      setbrandid(formData.brandid);
    }
  }, [formData.brand, formData.brandid]);

  // NEW: Sync sameAsManufacturer state
  useEffect(() => {
    setSameAsManufacturer(formData.sameAsManufacturer || false);
  }, [formData.sameAsManufacturer]);

  // Sync grand category selection
  useEffect(() => {
    if (formData.grandCategory && formData.grandCategory !== selectedGrandCategory) {
      setSelectedGrandCategory(formData.grandCategory);
    }
  }, [formData.grandCategory]);

  // Sync parent category selection
  useEffect(() => {
    if (formData.parentCategory && formData.parentCategory !== selectedParentCategory) {
      setSelectedParentCategory(formData.parentCategory);
    }
  }, [formData.parentCategory]);

  // Sync child category selection
  useEffect(() => {
    if (formData.childCategory && formData.childCategory !== selectedChildCategory) {
      setSelectedChildCategory(formData.childCategory);
    }
  }, [formData.childCategory]);

  // Sync grand child category selection
  useEffect(() => {
    if (formData.grandChildCategory && formData.grandChildCategory !== selectedGrandChildCategory) {
      setSelectedGrandChildCategory(formData.grandChildCategory);
    }
  }, [formData.grandChildCategory]);

  // NEW: Handle "Same as Manufacturer Details" checkbox
  const handleSameAsManufacturer = (checked) => {
    setSameAsManufacturer(checked);
    updateFormData('sameAsManufacturer', checked);
    
    if (checked) {
      // Copy manufacturer details to packer details
      updateFormData('packerName', formData.manufacturerName || '');
      updateFormData('packerAddress', formData.manufacturerAddress || '');
      updateFormData('packerPincode', formData.manufacturerPincode || '');
    } else {
      // Clear packer details
      updateFormData('packerName', '');
      updateFormData('packerAddress', '');
      updateFormData('packerPincode', '');
    }
  };

  // NEW: Auto-copy manufacturer details to packer when checkbox is enabled
  useEffect(() => {
    if (sameAsManufacturer) {
      updateFormData('packerName', formData.manufacturerName || '');
      updateFormData('packerAddress', formData.manufacturerAddress || '');
      updateFormData('packerPincode', formData.manufacturerPincode || '');
    }
  }, [formData.manufacturerName, formData.manufacturerAddress, formData.manufacturerPincode, sameAsManufacturer]);

  // Handle Grand Category Selection
const handleGrandCategoryChange = (grandCategoryId) => {
  setSelectedGrandCategory(grandCategoryId);
  
  // Find the selected grand category
  const selectedGrand = grandCategories.find(cat => cat._id === grandCategoryId);
  
  // Update formData with grand category
  updateFormData('grandCategory', grandCategoryId);
  updateFormData('categories', [grandCategoryId]);
  updateFormData('selectedCategoryName', selectedGrand?.categoryName || '');
  
  // Update category path display
  if (selectedGrand) {
    setCategoryPath(selectedGrand.categoryName);
  } else {
    setCategoryPath('');
  }
  
  // Set parent categories if available
  if (selectedGrand && selectedGrand.subCategories && selectedGrand.subCategories.length > 0) {
    setParentCategories(selectedGrand.subCategories);
  } else {
    setParentCategories([]);
  }
  
  // Reset all subsequent selections
  setSelectedParentCategory("");
  updateFormData('parentCategory', '');
  setChildCategories([]);
  setSelectedChildCategory("");
  updateFormData('childCategory', '');
  setGrandChildCategories([]);
  setSelectedGrandChildCategory("");
  updateFormData('grandChildCategory', '');
};

  // Handle Parent Category Selection
const handleParentCategoryChange = (parentCategoryId) => {
  setSelectedParentCategory(parentCategoryId);
  
  // Find the selected parent category
  const selectedParent = parentCategories.find(cat => cat._id === parentCategoryId);
  const selectedGrand = grandCategories.find(cat => cat._id === selectedGrandCategory);
  
  // Update formData with grand + parent category
  updateFormData('parentCategory', parentCategoryId);
  updateFormData('categories', [selectedGrandCategory, parentCategoryId]);
  updateFormData('selectedCategoryName', selectedParent?.categoryName || '');
  
  // Update category path display
  if (selectedGrand && selectedParent) {
    setCategoryPath(`${selectedGrand.categoryName} → ${selectedParent.categoryName}`);
  }
  
  // Set child categories if available
  if (selectedParent && selectedParent.subCategories && selectedParent.subCategories.length > 0) {
    setChildCategories(selectedParent.subCategories);
  } else {
    setChildCategories([]);
  }
  
  // Reset subsequent selections
  setSelectedChildCategory("");
  updateFormData('childCategory', '');
  setGrandChildCategories([]);
  setSelectedGrandChildCategory("");
  updateFormData('grandChildCategory', '');
};

// Handle Child Category Selection
const handleChildCategoryChange = (childCategoryId) => {
  setSelectedChildCategory(childCategoryId);
  
  // Find the selected child category
  const selectedChild = childCategories.find(cat => cat._id === childCategoryId);
  const selectedGrand = grandCategories.find(cat => cat._id === selectedGrandCategory);
  const selectedParent = parentCategories.find(cat => cat._id === selectedParentCategory);
  
  // Update formData with grand + parent + child category
  updateFormData('childCategory', childCategoryId);
  updateFormData('categories', [selectedGrandCategory, selectedParentCategory, childCategoryId]);
  updateFormData('selectedCategoryName', selectedChild?.categoryName || '');
  
  // Update category path display
  if (selectedGrand && selectedParent && selectedChild) {
    setCategoryPath(`${selectedGrand.categoryName} → ${selectedParent.categoryName} → ${selectedChild.categoryName}`);
  }
  
  // Set grand child categories if available
  if (selectedChild && selectedChild.subCategories && selectedChild.subCategories.length > 0) {
    setGrandChildCategories(selectedChild.subCategories);
  } else {
    setGrandChildCategories([]);
  }
  
  // Reset subsequent selections
  setSelectedGrandChildCategory("");
  updateFormData('grandChildCategory', '');
};

// Handle Grand Child Category Selection
const handleGrandChildCategoryChange = (grandChildCategoryId) => {
  setSelectedGrandChildCategory(grandChildCategoryId);
  
  // Find the selected grand child category
  const selectedGrandChild = grandChildCategories.find(cat => cat._id === grandChildCategoryId);
  const selectedGrand = grandCategories.find(cat => cat._id === selectedGrandCategory);
  const selectedParent = parentCategories.find(cat => cat._id === selectedParentCategory);
  const selectedChild = childCategories.find(cat => cat._id === selectedChildCategory);
  
  // Update formData with all category levels
  updateFormData('grandChildCategory', grandChildCategoryId);
  updateFormData('categories', [selectedGrandCategory, selectedParentCategory, selectedChildCategory, grandChildCategoryId]);
  updateFormData('selectedCategoryName', selectedGrandChild?.categoryName || '');
  
  // Update category path display
  if (selectedGrand && selectedParent && selectedChild && selectedGrandChild) {
    setCategoryPath(`${selectedGrand.categoryName} → ${selectedParent.categoryName} → ${selectedChild.categoryName} → ${selectedGrandChild.categoryName}`);
  }
};

const loadCategoryTree = async () => {
  try {
    setLoading(true);
    setError(false);
    
    let response;
    
    // Try servicesApi first (passed as prop)
    if (servicesApi && servicesApi.categories && servicesApi.categories.categoryTree) {
      console.log('Using servicesApi for categories');
      response = await servicesApi.categories.categoryTree({});
    } 
    // Fallback to api (passed as prop)
    else if (api && api.categories && api.categories.categoryTree) {
      console.log('Using api for categories');
      response = await api.categories.categoryTree({});
    } 
    else {
      console.error('No category API available in props');
      setError('Category API not available');
      setLoading(false);
      return;
    }
    
    
    // Handle different response structures
    let categories = [];
    if (response?.data?.subCategories) {
      categories = response.data.subCategories;
    } else if (response?.subCategories) {
      categories = response.subCategories;
    } else if (response?.data) {
      categories = response.data;
    } else if (Array.isArray(response)) {
      categories = response;
    }
    
    
    if (!categories || categories.length === 0) {
      console.warn('No categories found in response');
      setError('No categories available');
    } else {
      // Store grand categories (top level)
      setGrandCategories(categories);
      
      // Build category hierarchy and path on load
      if (formData.grandCategory) {
        const selectedGrand = categories.find(cat => cat._id === formData.grandCategory);
        
        if (selectedGrand) {
          let path = selectedGrand.categoryName;
          
          // Set parent categories
          if (selectedGrand.subCategories && selectedGrand.subCategories.length > 0) {
            setParentCategories(selectedGrand.subCategories);
            
            // If parent category exists in formData
            if (formData.parentCategory) {
              const selectedParent = selectedGrand.subCategories.find(
                cat => cat._id === formData.parentCategory
              );
              
              if (selectedParent) {
                path += ` → ${selectedParent.categoryName}`;
                console.log('Found parent category:', selectedParent.categoryName);
                
                // Set child categories
                if (selectedParent.subCategories && selectedParent.subCategories.length > 0) {
                  setChildCategories(selectedParent.subCategories);
                  
                  // If child category exists in formData
                  if (formData.childCategory) {
                    const selectedChild = selectedParent.subCategories.find(
                      cat => cat._id === formData.childCategory
                    );
                    
                    if (selectedChild) {
                      path += ` → ${selectedChild.categoryName}`;
                      
                      // Set grand child categories
                      if (selectedChild.subCategories && selectedChild.subCategories.length > 0) {
                        setGrandChildCategories(selectedChild.subCategories);
                        
                        // If grand child category exists in formData
                        if (formData.grandChildCategory) {
                          const selectedGrandChild = selectedChild.subCategories.find(
                            cat => cat._id === formData.grandChildCategory
                          );
                          
                          if (selectedGrandChild) {
                            path += ` → ${selectedGrandChild.categoryName}`;
                            
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          
          // Update the category path display
          setCategoryPath(path);
          console.log('Final category path:', path);
        } else {
          console.warn('Grand category not found in loaded categories');
        }
      }
    }
    
  } catch (err) {
    console.error('Error loading categories:', err);
    setError('Failed to load categories. Please try again.');
  } finally {
    setLoading(false);
  }
};

  // Handle brand click
  function handleBrandClick(name, id) {
    setbrandInput(name);
    setbrand(name);
    setbrandList([]);
    setbrandid(id);
    updateFormData('brand', name);
    updateFormData('brandid', id);
  }

  // Fetch brands
  function fetchbrands(name) {
    setbrandInput(name);
    setbrand("");
    setbrandid("");
    updateFormData('brand', "");
    updateFormData('brandid', null);
    
    api.brand
      .getManufacturers(searchManufacturers(name))
      .then((res) => {
        setbrandList(res.data);
      })
      .catch((err) => console.log(err));
  }

  const handleInputChange = (field, value, maxLength = null) => {
    updateFormData(field, value);
    
    if (maxLength) {
      setCharCount(prev => ({
        ...prev,
        [field]: value.length
      }));
    }
  };

  // Keyword functions
  const pushKeyword = (e) => {
    if ((e.keyCode === 13 || e.keyCode === 186) && currKeyword !== "") {
      const currentKeywords = formData.keywords || [];
      updateFormData('keywords', [...currentKeywords, currKeyword]);
      setcurrKeyword("");
    }
  };

  const pushKeywordclick = (e) => {
    e.preventDefault();
    if (currKeyword !== "") {
      const currentKeywords = formData.keywords || [];
      updateFormData('keywords', [...currentKeywords, currKeyword]);
      setcurrKeyword("");
    }
  };

  const delKeyword = (index) => {
    const currentKeywords = formData.keywords || [];
    const updatedKeywords = currentKeywords.filter((item, j) => j !== index);
    updateFormData('keywords', updatedKeywords);
  };

  return (
    <div className="basic-information-tab">
      <Form>
        {/* Product Title */}
        <Row className="mb-0">
          <Col xs={12}>
            <Form.Group>
              <Form.Label className="custom-form-label">
                Product Title <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                ref={productNameRef}
                type="text"
                placeholder="Enter product title"
                value={formData.productName || ''}
                onChange={(e) => handleInputChange('productName', e.target.value, 60)}
                maxLength={60}
                className={`form-control-sm custom-form-input ${validationErrors?.productName ? 'is-invalid' : ''}`}
              />
              {validationErrors?.productName && (
                <div className="invalid-feedback d-block">
                  {validationErrors.productName}
                </div>
              )}
              <Form.Text className="text-muted">
                {60 - charCount.productName} characters remaining
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        {/* Grand Category Selection */}
        <Row className="mb-1">
          <Col xs={4}>
            <Form.Group>
              <Form.Label className="custom-form-label">
                Grand Category <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                ref={grandCategoryRef}
                value={selectedGrandCategory}
                onChange={(e) => handleGrandCategoryChange(e.target.value)}
                className={`form-control-sm custom-form-input ${validationErrors?.grandCategory ? 'is-invalid' : ''}`}
                disabled={loading || grandCategories.length === 0}
              >
                <option value="">
                  {loading ? "Loading..." : "Select grand category"}
                </option>
                {grandCategories.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.categoryName}
                  </option>
                ))}
              </Form.Select>
              {validationErrors?.grandCategory && (
                <div className="invalid-feedback d-block">
                  {validationErrors.grandCategory}
                </div>
              )}
            </Form.Group>
          </Col>
          <Col xs={4}>
            <Form.Group>
              <Form.Label className="custom-form-label">
                Parent Category {parentCategories.length > 0 && <span className="text-danger">*</span>}
              </Form.Label>
              <Form.Select
                ref={parentCategoryRef}
                value={selectedParentCategory}
                onChange={(e) => handleParentCategoryChange(e.target.value)}
                className={`form-control-sm custom-form-input ${
                  parentCategories.length > 0 && validationErrors?.parentCategory 
                    ? 'is-invalid' 
                    : ''
                }`}
                disabled={loading || !selectedGrandCategory || parentCategories.length === 0}
              >
                <option value="">
                  {!selectedGrandCategory 
                    ? "Please select a grand category first" 
                    : parentCategories.length === 0 
                    ? "No parent categories available"
                    : "Select parent category"}
                </option>
                {parentCategories.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.categoryName}
                  </option>
                ))}
              </Form.Select>
              {parentCategories.length > 0 && validationErrors?.parentCategory && (
                <div className="invalid-feedback d-block">
                  {validationErrors.parentCategory}
                </div>
              )}
            </Form.Group>
          </Col>

          {/* Child Category Selection - Only show if parent has subcategories */}
          {childCategories.length > 0 && (
            <Col xs={4}>
              <Form.Group>
                <Form.Label className="custom-form-label">
                  Child Category <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  ref={childCategoryRef}
                  value={selectedChildCategory}
                  onChange={(e) => handleChildCategoryChange(e.target.value)}
                  className={`form-control-sm custom-form-input ${
                    validationErrors?.childCategory 
                      ? 'is-invalid' 
                      : ''
                  }`}
                  disabled={loading || !selectedParentCategory}
                >
                  <option value="">Select child category</option>
                  {childCategories.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.categoryName}
                    </option>
                  ))}
                </Form.Select>
                {validationErrors?.childCategory && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.childCategory}
                  </div>
                )}
              </Form.Group>
            </Col>
          )}

          {/* Grand Child Category Selection */}
          {grandChildCategories.length > 0 && (
            <Col xs={4}>
              <Form.Group>
                <Form.Label className="custom-form-label">
                  Grand Child Category <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  ref={grandChildCategoryRef}
                  value={selectedGrandChildCategory}
                  onChange={(e) => handleGrandChildCategoryChange(e.target.value)}
                  className={`form-control-sm custom-form-input ${
                    validationErrors?.grandChildCategory 
                      ? 'is-invalid' 
                      : ''
                  }`}
                  disabled={loading || !selectedChildCategory}
                >
                  <option value="">Select grand child category</option>
                  {grandChildCategories.map((item) => (
                    <option key={item._id} value={item._id}>
                      {item.categoryName}
                    </option>
                  ))}
                </Form.Select>
                {validationErrors?.grandChildCategory && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.grandChildCategory}
                  </div>
                )}
              </Form.Group>
            </Col>
          )}
        </Row>

        {/* Selected Category Path Display */}
        {categoryPath && (
          <Row className="mb-1">
            <Col xs={12}>
              <div className="selected-category-path">
                <strong>Selected Category Path:</strong>
                <div className="category-path-text">{categoryPath}</div>
              </div>
            </Col>
          </Row>
        )}

        {/* Country of Origin and Brand */}
        <Row className="mb-1">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="custom-form-label">
                Country of Origin <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                ref={countryOfOriginRef}
                value={formData.countryOfOrigin || ''}
                onChange={(e) => handleInputChange('countryOfOrigin', e.target.value)}
                className={`form-control-sm custom-form-input ${validationErrors?.countryOfOrigin ? 'is-invalid' : ''}`}
              >
                <option value="">Select country</option>
                {Object.entries(countries).map(([code, name]) => (
                  <option key={code} value={code}>
                    {name}
                  </option>
                ))}
              </Form.Select>
              {validationErrors?.countryOfOrigin && (
                <div className="invalid-feedback d-block">
                  {validationErrors.countryOfOrigin}
                </div>
              )}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="custom-form-label">
                Brand <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                ref={brandRef}
                type="text"
                placeholder="Enter brand name"
                value={brandInput}
                onChange={(e) => fetchbrands(e.target.value)}
                className={`form-control-sm custom-form-input ${validationErrors?.brand || validationErrors?.brandid ? 'is-invalid' : ''}`}
              />
              {(validationErrors?.brand || validationErrors?.brandid) && (
                <div className="invalid-feedback d-block">
                  {validationErrors.brand || validationErrors.brandid}
                </div>
              )}
              {brandList.length > 0 && (
                <ul className="brand_List_cntn">
                  {brandList.map((item, index) => (
                    <li
                      key={index}
                      className="brand_List text-black"
                      onClick={() => handleBrandClick(item.name, item.manufacturerId)}
                    >
                      {item.name}
                    </li>
                  ))}
                </ul>
              )}
              <Form.Text className="text-muted">
                {formData.brandid ? (
                  <span className="text-success">
                    <i className="bi bi-check-circle-fill me-1"></i>
                    Brand selected: {formData.brand}
                  </span>
                ) : (
                  'Search and select a brand from the dropdown'
                )}
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        {/* Keywords - Interactive Tag Input */}
        <Row className="mb-1">
          <Col xs={12}>
            <Form.Group>
              <Form.Label className="custom-form-label">
                Keywords <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                ref={keywordsRef}
                type="text"
                placeholder="Please enter keywords and separate them by pressing enter"
                value={currKeyword}
                onKeyDown={(e) => pushKeyword(e)}
                onChange={(e) => {
                  if (e.target.value !== ";") {
                    setcurrKeyword(e.target.value);
                  }
                }}
                className={`form-control-sm custom-form-input ${validationErrors?.keywords ? 'is-invalid' : ''}`}
              />
              {validationErrors?.keywords && (
                <div className="invalid-feedback d-block">
                  {validationErrors.keywords}
                </div>
              )}
              <Form.Text className="text-muted">
                Type keywords and press Enter to add them. Press semicolon (;) or Enter to add.
              </Form.Text>
              
              {currKeyword && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="mt-2"
                  onClick={pushKeywordclick}
                >
                  Add Keyword
                </Button>
              )}
              
              {formData.keywords && formData.keywords.length > 0 && (
                <div className="mt-3">
                  <div className="keyword-tags-container">
                    {formData.keywords.map((item, index) => (
                      <span className="keyword-tag" key={`keyword-${index}-${item}`}>
                        {item}
                        <button
                          type="button"
                          className="keyword-tag-close"
                          onClick={() => delKeyword(index)}
                          aria-label={`Remove ${item} keyword`}
                        >
                          &times;
                        </button>
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        {/* Short Description */}
        <Row className="mb-1">
          <Col xs={12}>
            <Form.Group>
              <Form.Label className="custom-form-label">
                Short Description <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                ref={shortDescriptionRef}
                as="textarea"
                rows={3}
                placeholder="Brief product description (max 160 characters)"
                value={formData.shortDescription || ''}
                onChange={(e) => handleInputChange('shortDescription', e.target.value, 160)}
                maxLength={160}
                className={`form-control-sm custom-form-input ${validationErrors?.shortDescription ? 'is-invalid' : ''}`}
              />
              {validationErrors?.shortDescription && (
                <div className="invalid-feedback d-block">
                  {validationErrors.shortDescription}
                </div>
              )}
              <Form.Text className="text-muted">
                {charCount.shortDescription}/160 characters
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        {/* Full Description */}
        <Row className="mb-1">
          <Col xs={12}>
            <Form.Group>
              <Form.Label className="custom-form-label">
                Full Description <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                ref={fullDescriptionRef}
                as="textarea"
                rows={6}
                placeholder="Detailed product description (minimum 100 characters, maximum 5000 characters)"
                value={formData.fullDescription || ''}
                onChange={(e) => handleInputChange('fullDescription', e.target.value, 5000)}
                maxLength={5000}
                className={`form-control-sm custom-form-input ${validationErrors?.fullDescription ? 'is-invalid' : ''}`}
              />
              {validationErrors?.fullDescription && (
                <div className="invalid-feedback d-block">
                  {validationErrors.fullDescription}
                </div>
              )}
              <Form.Text className="text-muted">
                {formData.fullDescription?.length || 0}/5000 characters (minimum 100 required)
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      </Form>
      
      <Row className="mt-3">
        <Col xs={6} className="text-start">
          <Button
            variant="secondary"
            onClick={() => window.history.back()}
            size="sm"
          >
            <i className="bi bi-chevron-left me-1"></i>
            Back to Products
          </Button>
        </Col>

        <Col xs={6} className="text-end">
          <Button
            onClick={onNext}
            size="sm"
            style={{ 
              backgroundColor: '#165b5b',
              borderColor: '#165b5b',
              color: 'white'
            }}
          >
            Save & Next <i className="bi bi-arrow-right ms-2"></i>
          </Button>
        </Col>
      </Row>

      <style jsx>{`
        .selected-category-path {
          background-color: #d4edda;
          border: 1px solid #c3e6cb;
          border-radius: 4px;
          padding: 12px 15px;
          margin-top: 10px;
        }
        
        .selected-category-path strong {
          display: block;
          margin-bottom: 5px;
          color: #155724;
          font-size: 14px;
          font-weight: 600;
        }
        
        .category-path-text {
          color: #155724;
          font-size: 13px;
          font-weight: 500;
        }
          
        .cursor-pointer {
          cursor: pointer;
        }
        .cursor-pointer:hover {
          background-color: #f8f9fa;
        }
        
        .keyword-tags-container {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 8px;
        }
        
        .keyword-tag {
          display: inline-flex;
          align-items: center;
          background-color: #d4edda;
          border: 1px solid #d4edda;
          border-radius: 20px;
          padding: 6px 12px;
          font-size: 10px;
          color: #000000ff;
          gap: 6px;
        }
        
        .keyword-tag-close {
          background: none;
          border: none;
          color: #000000ff;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          padding: 0;
          margin-left: 4px;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.2s;
        }
        
        .keyword-tag-close:hover {
          background-color: rgba(25, 118, 210, 0.1);
        }
        
        .keyword-tag-close:focus {
          outline: 2px solid #d4edda;
          outline-offset: 2px;
        }

        .brand_List_cntn {
          position: absolute;
          z-index: 1000;
          background: white;
          border: 1px solid #dee2e6;
          border-radius: 4px;
          margin-top: 2px;
          max-height: 200px;
          overflow-y: auto;
          width: calc(100% - 30px);
          list-style: none;
          padding: 0;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        .brand_List {
          padding: 8px 12px;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        
        .brand_List:hover {
          background-color: #165b5b;
        }
        
        /* Highlight invalid fields with red border */
        .is-invalid {
          border-color: #dc3545 !important;
        }
        
        .invalid-feedback {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 0.25rem;
        }
      `}</style>
    </div>
  );
};